/**
 * Converts a decimal hour value to a "H:MM" string (no leading zero on hours).
 * e.g. 9 → "9:00", 17 → "17:00", 7.43 → "7:25"
 *
 * @param {number} num  Decimal hours (0–24)
 * @returns {string}    "H:MM"
 */
export function convertNumberToHHMM(num) {
  const ms = num * 60 * 60 * 1000
  const timeString = new Date(ms).toISOString().slice(11, 16)
  const [hoursRaw, minutes] = timeString.split(':')
  return `${parseInt(hoursRaw, 10)}:${minutes}`
}

/**
 * Sums the total hours of direct sunlight from an array of [start, end] time ranges.
 *
 * Each range is a two-element array of decimal hours: [startHour, endHour].
 * Returns 0 for null / empty input — caller treats 0 as "no insolation data".
 *
 * @param {[number, number][] | null | undefined} ranges
 * @returns {number} Total sunlight hours (sum of all range spans)
 */
export function sumSunLightRanges(ranges) {
  if (!ranges || ranges.length === 0) return 0
  return ranges.reduce((sum, r) => sum + (r[1] - r[0]), 0)
}
